module.exports = __webpack_public_path__ + "packs/media/images/covid/covid_6-82ee3af48dbf8fee32a14e0cc05b1a7a.png";